import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "The Frame Is Everything",
    body: "Every shot is a decision. Composition, light, and movement are engineered to make your audience feel before they think.",
  },
  {
    n: "02",
    title: "Story Over Spectacle",
    body: "Gear matters, but story wins. From RED and ARRI cinema bodies to a single lens, the narrative always leads the technology.",
  },
  {
    n: "03",
    title: "Teach The Craft",
    body: "Creativity should be accessible. Learn to design and edit with free and AI tools — and if you run a non-profit, it's on the house.",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: i * 0.1 },
  }),
};

export const Manifesto = () => {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="py-28 sm:py-40 bg-[#050505]">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="font-body text-xs uppercase tracking-[0.3em] text-gray-500 mb-16"
        >
          The Manifesto
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {chapters.map((c, i) => (
            <motion.div
              key={c.n}
              custom={i}
              variants={reveal}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              data-testid={`manifesto-chapter-${c.n}`}
              className="border-t border-white/10 pt-8"
            >
              <span className="font-head text-6xl font-700 text-[#D90429] tracking-tighter">{c.n}</span>
              <h3 className="font-head uppercase text-2xl sm:text-3xl tracking-tight text-white mt-6 leading-tight">
                {c.title}
              </h3>
              <p className="font-body text-base text-gray-400 leading-relaxed mt-4">{c.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
